module.exports = __webpack_public_path__ + "img/group16421.63da19ab.svg";